// extracted by mini-css-extract-plugin
export default {"linksSection":"_H-z"};